import z from 'zod';
export const projectUpdatedWebhookSchema = z.looseObject({
    type: z.literal('project-updated'),
    projectId: z.string(),
    correlationId: z.string().optional(),
    totalUniquePageCount: z.number(),
    documents: z.array(z.object({
        id: z.string(),
        filename: z.string(),
        pageIds: z.array(z.string()),
    })),
});
//# sourceMappingURL=project-updated.webhook.js.map